import {
    Timeline,
    TimelineConnector,
    TimelineDot,
    TimelineItem,
    TimelineSeparator,
} from '@mui/lab';
import { ListItemAvatar } from '@mui/material';

const TimelineDots = () => {
    return (
        <ListItemAvatar>
            <Timeline sx={{ pl: 0 }}>
                <TimelineItem
                    sx={{
                        pl: 0,
                        '&:before': {
                            p: 0,
                        },
                    }}>
                    <TimelineSeparator>
                        <TimelineConnector
                            sx={{
                                backgroundColor: 'rgba(0, 0, 0, 0)',
                                border: (theme) =>
                                    `1px dashed ${theme.palette.grey[200]}`,
                                width: 0,
                            }}
                        />
                        <TimelineDot
                            variant="outlined"
                            sx={{ color: 'primary.main', margin: '4.5px 0' }}
                        />
                        <TimelineConnector
                            sx={{
                                backgroundColor: 'rgba(0, 0, 0, 0)',
                                border: (theme) =>
                                    `1px dashed ${theme.palette.grey[200]}`,
                                width: 0,
                            }}
                        />
                    </TimelineSeparator>
                </TimelineItem>
            </Timeline>
        </ListItemAvatar>
    );
};

export default TimelineDots;
